import React from 'react';
import PropTypes from 'prop-types';
import noImage from 'assets/img/users/no-image.jpg';
import PageSpinner from 'components/PageSpinner';
import { Card } from 'reactstrap';
import TableCustomHeader from 'components/dataTables/tableCustomHeader';
import DataTables from 'components/dataTables';
import Avatar from 'components/Avatar';

const PostUsers = (props) => {

    const [pagination, setPagination] = React.useState({
        page: 0,
        page_limit: 10,
    })
    const [order, setOrder] = React.useState({
        order_by: 'name',
        direction: 'asc'
    })
    const profilePicture = (value, tableMeta, updateValue) => {
        return (<Avatar src={(value) ? value : noImage}  />);
    }
    const columns = [
        {
            name: "id",
            label: "Id",
            options: {
                display: false,

            }
        },
        {
            name: "avatar",
            label: "Image",
            options: {
                customBodyRender: profilePicture,
                sort: true,
                customHeadRender: (columnMeta, updateDirection) => {
                    return <TableCustomHeader key={1} itemkey={1} order={order} columnMeta={columnMeta} updateDirection={updateDirection} />
                }
            }
        },
        {
            name: "name",
            label: "Name",
            options: {
                sort: true,
                customHeadRender: (columnMeta, updateDirection) => {
                    return <TableCustomHeader key={2} itemkey={2} order={order} columnMeta={columnMeta} updateDirection={updateDirection} />
                }
            }
        },
        {
            name: "username",
            label: "Username",
            options: {
                sort: true,
                customHeadRender: (columnMeta, updateDirection) => {
                    return <TableCustomHeader key={3} itemkey={3} order={order} columnMeta={columnMeta} updateDirection={updateDirection} />
                }
            }
        },
        {
            name: "email",
            label: "Email",
            options: {
                sort: true,
                customHeadRender: (columnMeta, updateDirection) => {
                    return <TableCustomHeader key={4} itemkey={4} order={order} columnMeta={columnMeta} updateDirection={updateDirection} />
                }
            }
        },
        {
            name: "phone",
            label: "Phone",
            options: {
                sort: true,
                customHeadRender: (columnMeta, updateDirection) => {
                    return <TableCustomHeader key={5} itemkey={5} order={order} columnMeta={columnMeta} updateDirection={updateDirection} />
                }
            }
        }

    ];
    React.useEffect(()=>{
        props.handleTable(order,pagination);
    },[order,pagination])

    const options = {
        tableId: 'datatable',
        filterType: 'checkbox',
        search: false,
        searchOpen: false,
        responsive: "simple",
        filter: false,
        download: false,
        print: false,
        selectableRows: 'none',
        viewColumns: false,
        count: props.totalRecord,
        serverSide: true,
        page: pagination.page,
        rowsPerPage: pagination.page_limit,
        onColumnSortChange: (changedColumn) => {
            setOrder({
                order_by: changedColumn,
                direction: (order.direction === 'asc') ? 'desc' : 'asc'
            })
        },
        onTableChange: (action, tableState) => {
            switch (action) {
                case 'changePage':
                    setPagination({
                        page_limit: pagination.page_limit,
                        page: tableState.page
                    })
                    break;
                case 'changeRowsPerPage':
                    setPagination({
                        page_limit: tableState.rowsPerPage,
                        page: 0,
                    })
                    break;
                default:
                    break
            }
        }
    };
    return (
        <Card className="mb-3">
            {props.isLoading ? <PageSpinner />
                : <DataTables data={props.data} columns={columns} options={options} />
            }
        </Card>
    );
}
PostUsers.propTypes = {
    data: PropTypes.array,
    count: PropTypes.number,
    handleTable: PropTypes.func,
};
export default PostUsers